import {
  ApiGetNoToken,
	ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	icd10Api
} from 'interface/endpoints'
import {
	DiseaseResultList,
	DiseaseNodeResult
} from './types'
import { useCallback } from 'react'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const SearchICD10Diseases = (
	word: string,
	options: { offset?: number, limit?: number, dataSetId?: number }
) => ApiGetNoToken<DiseaseResultList>(
  icd10Api(`/search/${word}`, { ...options, t })
)
export const useSearchICD10Diseases = (
	word: string,
	options: { limit?: number, dataSetId?: number }
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			return ApiGetWithToken<DiseaseResultList>(
				apiAccess,
				icd10Api(`/search/${word}`, { ...options, t }),
				cancelToken
			)
		},
		[word, options]
	)
)

export const useGetICD10DiseasesNode = (
	icd10code: string | null,
	dataSetId?: number,
	offset?: number,
	limit?: number
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!icd10code) return null
			return ApiGetWithToken<DiseaseNodeResult>(
				apiAccess,
			  icd10Api(`/node/${icd10code}`, { dataSetId, offset, limit, t }),
				cancelToken
			)
		},
		[icd10code, dataSetId, offset, limit]
	)
)

export const useListICD10Diseases = (
	icd10code: string | null,
	dataSetId?: number
) => {
	return useApiFetch(
		useCallback(
			(apiAccess, cancelToken) => {
				if (!icd10code) return null
				return ApiGetWithToken<DiseaseResultList>(
					apiAccess,
					icd10Api(`/${icd10code}`, { dataSetId, t }),
					cancelToken
				)
			},
			[icd10code, dataSetId]
		)
	)
}
